import React from "react";

import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import { useTranslation } from "react-i18next";

import {
  ModalDescription,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "./styles";
import { Button } from "@caelor/ui";

const WarningModal = ({ isOpen, onClose, onConfirm, macroName }) => {
  const { t } = useTranslation();

  return (
    <ModalTransition>
      {isOpen && (
        <Modal
          width="450px"
          shouldCloseOnEscapePress
          isChromeless
          onClose={onClose}
        >
          <ModalContent>
            <ModalHeader>{t("missing-links")}</ModalHeader>
            <ModalDescription>
              {t(`warning-modal.empty-link.${macroName}`)}
            </ModalDescription>

            <ModalFooter>
              <Button appearance="subtle" onClick={onClose}>
                {t("cancel")}
              </Button>

              <Button
                appearance="primary"
                onClick={() => {
                  onClose();
                  onConfirm();
                }}
              >
                {t("add-to-page")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default WarningModal;
